<div class="group-header">
  <span class="group-label">{{ label }}</span>
  <span class="find-in-chat" (click)="onFindInChat()">
      <img [src]="'svg/expand.svg' | assetVersion" alt="find in chat">
    Find in chat</span>
</div>
